"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRuleV2 = exports.getRuleV2SerializerFromType = exports.getRuleV2Serializer = void 0;
const additionalSigner_1 = require("./additionalSigner");
const all_1 = require("./all");
const amount_1 = require("./amount");
const any_1 = require("./any");
const namespace_1 = require("./namespace");
const not_1 = require("./not");
const pass_1 = require("./pass");
const pdaMatch_1 = require("./pdaMatch");
const programOwned_1 = require("./programOwned");
const programOwnedList_1 = require("./programOwnedList");
const programOwnedTree_1 = require("./programOwnedTree");
const pubkeyListMatch_1 = require("./pubkeyListMatch");
const pubkeyMatch_1 = require("./pubkeyMatch");
const pubkeyTreeMatch_1 = require("./pubkeyTreeMatch");
const ruleType_1 = require("./ruleType");
const getRuleV2Serializer = () => ({
    description: 'RuleV2',
    fixedSize: null,
    maxSize: null,
    serialize: (rule) => (0, exports.getRuleV2SerializerFromType)(rule.type).serialize(rule),
    deserialize: (buffer, offset = 0) => {
        const type = buffer[offset];
        const typeAsString = (0, ruleType_1.getRuleTypeV2AsString)(type);
        return (0, exports.getRuleV2SerializerFromType)(typeAsString).deserialize(buffer, offset);
    },
});
exports.getRuleV2Serializer = getRuleV2Serializer;
const getRuleV2SerializerFromType = (type) => (() => {
    switch (type) {
        case 'AdditionalSigner':
            return (0, additionalSigner_1.getAdditionalSignerRuleV2Serializer)();
        case 'All':
            return (0, all_1.getAllRuleV2Serializer)();
        case 'Amount':
            return (0, amount_1.getAmountRuleV2Serializer)();
        case 'Any':
            return (0, any_1.getAnyRuleV2Serializer)();
        // case 'Frequency':
        //   return getFrequencyRuleV2Serializer();
        // case 'IsWallet':
        //   return getIsWalletRuleV2Serializer();
        case 'Namespace':
            return (0, namespace_1.getNamespaceRuleV2Serializer)();
        case 'Not':
            return (0, not_1.getNotRuleV2Serializer)();
        case 'Pass':
            return (0, pass_1.getPassRuleV2Serializer)();
        case 'PdaMatch':
            return (0, pdaMatch_1.getPdaMatchRuleV2Serializer)();
        case 'ProgramOwned':
            return (0, programOwned_1.getProgramOwnedRuleV2Serializer)();
        case 'ProgramOwnedList':
            return (0, programOwnedList_1.getProgramOwnedListRuleV2Serializer)();
        case 'ProgramOwnedTree':
            return (0, programOwnedTree_1.getProgramOwnedTreeRuleV2Serializer)();
        case 'PubkeyListMatch':
            return (0, pubkeyListMatch_1.getPubkeyListMatchRuleV2Serializer)();
        case 'PubkeyMatch':
            return (0, pubkeyMatch_1.getPubkeyMatchRuleV2Serializer)();
        case 'PubkeyTreeMatch':
            return (0, pubkeyTreeMatch_1.getPubkeyTreeMatchRuleV2Serializer)();
        default:
            throw new Error(`Unknown rule type: ${type}`);
    }
})();
exports.getRuleV2SerializerFromType = getRuleV2SerializerFromType;
const isRuleV2 = (rule) => 'type' in rule;
exports.isRuleV2 = isRuleV2;
//# sourceMappingURL=rule.js.map